// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.regi_pg_container {
  font-family: 'Manrope', sans-serif;
  display: flex;
  min-height: 100vh;
  width: 100%;
  background: #fcfbf9;
  overflow: hidden;
}


.regi_pg_left {
  position: relative;
  flex: 0 0 46%;
  min-height: 100vh;
  padding: 48px 56px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
 background-image: linear-gradient(to top, rgb(100, 28, 100), rgb(255, 255, 255),white);  overflow: hidden;

  overflow: hidden;
}

.regi_pg_left::before {
  content: '';
  position: absolute;
  inset: -20% -20% -20% -20%;
  background-image: radial-gradient(#f5a83c 1.4px, transparent 1.4px);
  background-size: 26px 26px;
  opacity: 0.10;
  animation: dotDrift 30s linear infinite;
  pointer-events: none;
}

.regi_pg_left::after {
  content: '';
  position: absolute;
  top: -120px;
  right: -120px;
  width: 380px;
  height: 380px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(245, 168, 60, 0.20) 0%, rgba(245, 168, 60, 0) 70%);
  animation: glowPulse 6s ease-in-out infinite;
  pointer-events: none;
}

@keyframes dotDrift {
  0% { background-position: 0 0; }
  100% { background-position: 260px 130px; }
}

@keyframes glowPulse {
  0%, 100% { transform: scale(1); opacity: 0.8; }
  50% { transform: scale(1.15); opacity: 1; }
}

.regi_pg_logo_row {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  gap:25px;
  opacity: 0;
  animation: fadeInDown 0.7s ease forwards;
     margin-top:18rem;
}

.regi_pg_logo_side_img,
.regi_pg_logo_img {
  /* border-radius: 50%; */
  object-fit: contain;
  background: rgb(255, 255, 255);
  padding: 20px;
  height: 188px;
  width: 188px;

}

@keyframes fadeInDown {
  from { opacity: 0; transform: translateY(-14px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(18px); }
  to { opacity: 1; transform: translateY(0); }
}

/* ============================================================
   RIGHT PANEL — the form workspace
   ============================================================ */

.regi_pg_right {
  flex: 1 1;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 32px;
  background: #fcfbf9;
  overflow-y: auto;
}

.regi_pg_form_wrap {
  width: 100%;
  max-width: 420px;
  opacity: 0;
  animation: fadeInUp 0.6s ease 0.1s forwards;
}

.regi_pg_title {
  font-family: 'Manrope', sans-serif;
  font-weight: 800;
  font-size: 27px;
  color: #171b2e;
  margin: 0 0 6px;
  letter-spacing: -0.3px;
}

.regi_pg_subtitle {
  font-family: 'Manrope', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #6b7089;
  margin: 0 0 30px;
  line-height: 1.5;
}

.regi_pg_form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.regi_pg_field {
  display: flex;
  flex-direction: column;
  gap: 7px;
  opacity: 0;
  animation: fadeInUp 0.5s ease forwards;
}

.regi_pg_field:nth-of-type(1) { animation-delay: 0.15s; }
.regi_pg_field:nth-of-type(2) { animation-delay: 0.22s; }
.regi_pg_field:nth-of-type(3) { animation-delay: 0.29s; }
.regi_pg_field:nth-of-type(4) { animation-delay: 0.36s; }

.regi_pg_label {
  font-family: 'Manrope', sans-serif;
  font-weight: 600;
  font-size: 13.5px;
  color: #262b45;
}

.regi_pg_required {
  color: #e0633f;
  font-weight: 700;
}

.regi_pg_input {
  font-family: 'Manrope', sans-serif;
  font-weight: 500;
  font-size: 14.5px;
  color: #1b1f33;
  padding: 13px 15px;
  width: 100%;
  border-radius: 11px;
  border: 1.5px solid #e6e3dc;
  background: #ffffff;
  outline: none;
  transition: border-color 0.25s ease, box-shadow 0.25s ease, transform 0.15s ease;
}

.regi_pg_input::placeholder {
  color: #a7abc0;
  font-weight: 400;
}

.regi_pg_input:hover {
  border-color: #d4d0c6;
}

.regi_pg_input:focus {
  border-color: #f5a83c;
  box-shadow: 0 0 0 4px rgba(245, 168, 60, 0.16);
  transform: translateY(-1px);
}

.regi_pg_error_text {
  font-family: 'Manrope', sans-serif;
  font-weight: 500;
  font-size: 12.5px;
  color: #d8455c;
  animation: shakeIn 0.35s ease;
}

@keyframes shakeIn {
  0% { opacity: 0; transform: translateX(-6px); }
  40% { transform: translateX(4px); }
  70% { transform: translateX(-2px); }
  100% { opacity: 1; transform: translateX(0); }
}

.regi_pg_password_wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.regi_pg_input_password {
  padding-right: 46px;
}

.regi_pg_eye_btn {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8b8fa3;
  cursor: pointer;
  border-radius: 6px;
  transition: color 0.2s ease, transform 0.2s ease, background 0.2s ease;
}

.regi_pg_eye_btn:hover {
  color: #f5a83c;
  background: rgba(245, 168, 60, 0.10);
  transform: translateY(-50%) scale(1.08);
}

.regi_pg_checkbox_row {
  display: flex;
  align-items: center;
  gap: 10px;
  opacity: 0;
  animation: fadeInUp 0.5s ease 0.42s forwards;
}

.regi_pg_checkbox {
  appearance: none;
  -webkit-appearance: none;
  width: 19px;
  height: 19px;
  min-width: 19px;
  border-radius: 6px;
  border: 1.6px solid #d4d0c6;
  background: #ffffff;
  cursor: pointer;
  position: relative;
  transition: background 0.2s ease, border-color 0.2s ease, transform 0.15s ease;
}

.regi_pg_checkbox:checked {
  background: #f5a83c;
  border-color: #f5a83c;
  transform: scale(1.05);
}

.regi_pg_checkbox:checked::after {
  content: '';
  position: absolute;
  left: 5px;
  top: 1px;
  width: 5px;
  height: 9px;
  border: solid #171b2e;
  border-width: 0 2px 2px 0;
  transform: rotate(40deg);
}

.regi_pg_checkbox_label {
  font-family: 'Manrope', sans-serif;
  font-weight: 500;
  font-size: 13.5px;
  color: #4b5165;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.regi_pg_submit_btn {
  font-family: 'Manrope', sans-serif;
  font-weight: 700;
  font-size: 15px;
  color: #171b2e;
  padding: 14px 20px;
  width: 100%;
  border: none;
  border-radius: 11px;
  background: #f5a83c;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  position: relative;
  overflow: hidden;
  margin-top: 4px;
  opacity: 0;
  animation: fadeInUp 0.5s ease 0.5s forwards;
  transition: background 0.25s ease, transform 0.15s ease, box-shadow 0.25s ease;
}

.regi_pg_submit_btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -60%;
  width: 50%;
  height: 100%;
  background: linear-gradient(120deg, transparent, rgba(255, 255, 255, 0.45), transparent);
  transform: skewX(-20deg);
  transition: left 0.6s ease;
}

.regi_pg_submit_btn:hover:not(:disabled) {
  background: #e89323;
  box-shadow: 0 8px 20px rgba(245, 168, 60, 0.35);
  transform: translateY(-2px);
}

.regi_pg_submit_btn:hover:not(:disabled)::before {
  left: 120%;
}

.regi_pg_submit_btn:active:not(:disabled) {
  transform: translateY(0);
}

.regi_pg_submit_btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.regi_pg_arrow {
  display: inline-block;
  transition: transform 0.25s ease;
}

.regi_pg_submit_btn:hover:not(:disabled) .regi_pg_arrow {
  transform: translateX(4px);
}

.regi_pg_login_text {
  font-family: 'Manrope', sans-serif;
  font-weight: 500;
  font-size: 13.5px;
  color: #6b7089;
  text-align: center;
  margin: 6px 0 0;
  opacity: 0;
  animation: fadeInUp 0.5s ease 0.58s forwards;
}

.regi_pg_login_link {
  font-weight: 700;
  color: #d8792e;
  cursor: pointer;
  position: relative;
  transition: color 0.2s ease;
}

.regi_pg_login_link::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -2px;
  width: 0%;
  height: 1.5px;
  background: #d8792e;
  transition: width 0.25s ease;
}

.regi_pg_login_link:hover {
  color: #b56010;
}

.regi_pg_login_link:hover::after {
  width: 100%;
}

/* ============================================================
   RESPONSIVE — tablet
   ============================================================ */

@media (max-width: 1024px) {
  .regi_pg_left {
    flex: 0 0 40%;
    padding: 40px 40px;
  }

 

  .regi_pg_right {
    padding: 40px 28px;
  }
}

@media (max-width: 860px) {
  .regi_pg_container {
    flex-direction: column;
  }

  .regi_pg_left {
    flex: none;
    min-height: auto;
    padding: 36px 32px 44px;
  }

  .regi_pg_left::before {
    animation-duration: 40s;
  }

 
  .regi_pg_right {
    min-height: auto;
    padding: 40px 24px 56px;
  }
}

/* ============================================================
   RESPONSIVE — mobile
   ============================================================ */

@media (max-width: 560px) {
  .regi_pg_left {
    padding: 28px 22px 36px;
  }

  .regi_pg_logo_side_img,
  .regi_pg_logo_img {
  /* border-radius: 50%; */
  object-fit: contain;
  background: rgb(255, 255, 255);
  padding: 20px;
  height: 108px;
  width: 108px;
  margin-top: -15rem;
  }

  .regi_pg_right {
    padding: 32px 18px 48px;
  }

  .regi_pg_title {
    font-size: 23px;
  }

  .regi_pg_form {
    gap: 15px;
  }

  .regi_pg_input {
    padding: 12px 13px;
    font-size: 14px;
  }

  .regi_pg_submit_btn {
    padding: 13px 18px;
    font-size: 14.5px;
  }
}


/* ============================================================
   Respect reduced motion
   ============================================================ */

@media (prefers-reduced-motion: reduce) {
  .regi_pg_left::before,
  .regi_pg_left::after,
  .regi_pg_logo_row,
 

  .regi_pg_stats,
  .regi_pg_form_wrap,
  .regi_pg_field,
  .regi_pg_checkbox_row,
  .regi_pg_submit_btn,
  .regi_pg_login_text {
    animation: none !important;
    opacity: 1 !important;
    transform: none !important;
  }
} `, "",{"version":3,"sources":["webpack://./src/Auth/RegisterPage/RegisterPage.css"],"names":[],"mappings":";AACA;EACE,kCAAkC;EAClC,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;;AAGA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;CAC/B,sFAAsF,GAAG,gBAAgB;;EAExG,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,mEAAmE;EACnE,0BAA0B;EAC1B,aAAa;EACb,uCAAuC;EACvC,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,2FAA2F;EAC3F,4CAA4C;EAC5C,oBAAoB;AACtB;;AAEA;EACE,KAAK,wBAAwB,EAAE;EAC/B,OAAO,gCAAgC,EAAE;AAC3C;;AAEA;EACE,WAAW,mBAAmB,EAAE,YAAY,EAAE;EAC9C,MAAM,sBAAsB,EAAE,UAAU,EAAE;AAC5C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,wCAAwC;KACrC,gBAAgB;AACrB;;AAEA;;EAEE,wBAAwB;EACxB,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,aAAa;EACb,YAAY;;AAEd;;AAEA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACjD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;;iEAEiE;;AAEjE;EACE,SAAO;EACP,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,2CAA2C;AAC7C;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,UAAU;EACV,sCAAsC;AACxC;;AAEA,gCAAgC,sBAAsB,EAAE;AACxD,gCAAgC,sBAAsB,EAAE;AACxD,gCAAgC,sBAAsB,EAAE;AACxD,gCAAgC,sBAAsB,EAAE;;AAExD;EACE,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,gFAAgF;AAClF;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,KAAK,UAAU,EAAE,2BAA2B,EAAE;EAC9C,MAAM,0BAA0B,EAAE;EAClC,MAAM,2BAA2B,EAAE;EACnC,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,sEAAsE;AACxE;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,8EAA8E;AAChF;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,2CAA2C;EAC3C,8EAA8E;AAChF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,UAAU;EACV,YAAY;EACZ,wFAAwF;EACxF,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;;iEAEiE;;AAEjE;EACE;IACE,aAAa;IACb,kBAAkB;EACpB;;;;EAIA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;;EAGA;IACE,gBAAgB;IAChB,uBAAuB;EACzB;AACF;;AAEA;;iEAEiE;;AAEjE;EACE;IACE,uBAAuB;EACzB;;EAEA;;EAEA,wBAAwB;EACxB,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;;AAGA;;iEAEiE;;AAEjE;EACE;;;;;;;;;;;IAWE,0BAA0B;IAC1B,qBAAqB;IACrB,0BAA0B;EAC5B;AACF","sourcesContent":["\n.regi_pg_container {\n  font-family: 'Manrope', sans-serif;\n  display: flex;\n  min-height: 100vh;\n  width: 100%;\n  background: #fcfbf9;\n  overflow: hidden;\n}\n\n\n.regi_pg_left {\n  position: relative;\n  flex: 0 0 46%;\n  min-height: 100vh;\n  padding: 48px 56px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n background-image: linear-gradient(to top, rgb(100, 28, 100), rgb(255, 255, 255),white);  overflow: hidden;\n\n  overflow: hidden;\n}\n\n.regi_pg_left::before {\n  content: '';\n  position: absolute;\n  inset: -20% -20% -20% -20%;\n  background-image: radial-gradient(#f5a83c 1.4px, transparent 1.4px);\n  background-size: 26px 26px;\n  opacity: 0.10;\n  animation: dotDrift 30s linear infinite;\n  pointer-events: none;\n}\n\n.regi_pg_left::after {\n  content: '';\n  position: absolute;\n  top: -120px;\n  right: -120px;\n  width: 380px;\n  height: 380px;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(245, 168, 60, 0.20) 0%, rgba(245, 168, 60, 0) 70%);\n  animation: glowPulse 6s ease-in-out infinite;\n  pointer-events: none;\n}\n\n@keyframes dotDrift {\n  0% { background-position: 0 0; }\n  100% { background-position: 260px 130px; }\n}\n\n@keyframes glowPulse {\n  0%, 100% { transform: scale(1); opacity: 0.8; }\n  50% { transform: scale(1.15); opacity: 1; }\n}\n\n.regi_pg_logo_row {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  gap:25px;\n  opacity: 0;\n  animation: fadeInDown 0.7s ease forwards;\n     margin-top:18rem;\n}\n\n.regi_pg_logo_side_img,\n.regi_pg_logo_img {\n  /* border-radius: 50%; */\n  object-fit: contain;\n  background: rgb(255, 255, 255);\n  padding: 20px;\n  height: 188px;\n  width: 188px;\n\n}\n\n@keyframes fadeInDown {\n  from { opacity: 0; transform: translateY(-14px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes fadeInUp {\n  from { opacity: 0; transform: translateY(18px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n/* ============================================================\n   RIGHT PANEL — the form workspace\n   ============================================================ */\n\n.regi_pg_right {\n  flex: 1;\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 32px;\n  background: #fcfbf9;\n  overflow-y: auto;\n}\n\n.regi_pg_form_wrap {\n  width: 100%;\n  max-width: 420px;\n  opacity: 0;\n  animation: fadeInUp 0.6s ease 0.1s forwards;\n}\n\n.regi_pg_title {\n  font-family: 'Manrope', sans-serif;\n  font-weight: 800;\n  font-size: 27px;\n  color: #171b2e;\n  margin: 0 0 6px;\n  letter-spacing: -0.3px;\n}\n\n.regi_pg_subtitle {\n  font-family: 'Manrope', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  color: #6b7089;\n  margin: 0 0 30px;\n  line-height: 1.5;\n}\n\n.regi_pg_form {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.regi_pg_field {\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n  opacity: 0;\n  animation: fadeInUp 0.5s ease forwards;\n}\n\n.regi_pg_field:nth-of-type(1) { animation-delay: 0.15s; }\n.regi_pg_field:nth-of-type(2) { animation-delay: 0.22s; }\n.regi_pg_field:nth-of-type(3) { animation-delay: 0.29s; }\n.regi_pg_field:nth-of-type(4) { animation-delay: 0.36s; }\n\n.regi_pg_label {\n  font-family: 'Manrope', sans-serif;\n  font-weight: 600;\n  font-size: 13.5px;\n  color: #262b45;\n}\n\n.regi_pg_required {\n  color: #e0633f;\n  font-weight: 700;\n}\n\n.regi_pg_input {\n  font-family: 'Manrope', sans-serif;\n  font-weight: 500;\n  font-size: 14.5px;\n  color: #1b1f33;\n  padding: 13px 15px;\n  width: 100%;\n  border-radius: 11px;\n  border: 1.5px solid #e6e3dc;\n  background: #ffffff;\n  outline: none;\n  transition: border-color 0.25s ease, box-shadow 0.25s ease, transform 0.15s ease;\n}\n\n.regi_pg_input::placeholder {\n  color: #a7abc0;\n  font-weight: 400;\n}\n\n.regi_pg_input:hover {\n  border-color: #d4d0c6;\n}\n\n.regi_pg_input:focus {\n  border-color: #f5a83c;\n  box-shadow: 0 0 0 4px rgba(245, 168, 60, 0.16);\n  transform: translateY(-1px);\n}\n\n.regi_pg_error_text {\n  font-family: 'Manrope', sans-serif;\n  font-weight: 500;\n  font-size: 12.5px;\n  color: #d8455c;\n  animation: shakeIn 0.35s ease;\n}\n\n@keyframes shakeIn {\n  0% { opacity: 0; transform: translateX(-6px); }\n  40% { transform: translateX(4px); }\n  70% { transform: translateX(-2px); }\n  100% { opacity: 1; transform: translateX(0); }\n}\n\n.regi_pg_password_wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.regi_pg_input_password {\n  padding-right: 46px;\n}\n\n.regi_pg_eye_btn {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #8b8fa3;\n  cursor: pointer;\n  border-radius: 6px;\n  transition: color 0.2s ease, transform 0.2s ease, background 0.2s ease;\n}\n\n.regi_pg_eye_btn:hover {\n  color: #f5a83c;\n  background: rgba(245, 168, 60, 0.10);\n  transform: translateY(-50%) scale(1.08);\n}\n\n.regi_pg_checkbox_row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  opacity: 0;\n  animation: fadeInUp 0.5s ease 0.42s forwards;\n}\n\n.regi_pg_checkbox {\n  appearance: none;\n  -webkit-appearance: none;\n  width: 19px;\n  height: 19px;\n  min-width: 19px;\n  border-radius: 6px;\n  border: 1.6px solid #d4d0c6;\n  background: #ffffff;\n  cursor: pointer;\n  position: relative;\n  transition: background 0.2s ease, border-color 0.2s ease, transform 0.15s ease;\n}\n\n.regi_pg_checkbox:checked {\n  background: #f5a83c;\n  border-color: #f5a83c;\n  transform: scale(1.05);\n}\n\n.regi_pg_checkbox:checked::after {\n  content: '';\n  position: absolute;\n  left: 5px;\n  top: 1px;\n  width: 5px;\n  height: 9px;\n  border: solid #171b2e;\n  border-width: 0 2px 2px 0;\n  transform: rotate(40deg);\n}\n\n.regi_pg_checkbox_label {\n  font-family: 'Manrope', sans-serif;\n  font-weight: 500;\n  font-size: 13.5px;\n  color: #4b5165;\n  cursor: pointer;\n  user-select: none;\n}\n\n.regi_pg_submit_btn {\n  font-family: 'Manrope', sans-serif;\n  font-weight: 700;\n  font-size: 15px;\n  color: #171b2e;\n  padding: 14px 20px;\n  width: 100%;\n  border: none;\n  border-radius: 11px;\n  background: #f5a83c;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  position: relative;\n  overflow: hidden;\n  margin-top: 4px;\n  opacity: 0;\n  animation: fadeInUp 0.5s ease 0.5s forwards;\n  transition: background 0.25s ease, transform 0.15s ease, box-shadow 0.25s ease;\n}\n\n.regi_pg_submit_btn::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -60%;\n  width: 50%;\n  height: 100%;\n  background: linear-gradient(120deg, transparent, rgba(255, 255, 255, 0.45), transparent);\n  transform: skewX(-20deg);\n  transition: left 0.6s ease;\n}\n\n.regi_pg_submit_btn:hover:not(:disabled) {\n  background: #e89323;\n  box-shadow: 0 8px 20px rgba(245, 168, 60, 0.35);\n  transform: translateY(-2px);\n}\n\n.regi_pg_submit_btn:hover:not(:disabled)::before {\n  left: 120%;\n}\n\n.regi_pg_submit_btn:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.regi_pg_submit_btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.regi_pg_arrow {\n  display: inline-block;\n  transition: transform 0.25s ease;\n}\n\n.regi_pg_submit_btn:hover:not(:disabled) .regi_pg_arrow {\n  transform: translateX(4px);\n}\n\n.regi_pg_login_text {\n  font-family: 'Manrope', sans-serif;\n  font-weight: 500;\n  font-size: 13.5px;\n  color: #6b7089;\n  text-align: center;\n  margin: 6px 0 0;\n  opacity: 0;\n  animation: fadeInUp 0.5s ease 0.58s forwards;\n}\n\n.regi_pg_login_link {\n  font-weight: 700;\n  color: #d8792e;\n  cursor: pointer;\n  position: relative;\n  transition: color 0.2s ease;\n}\n\n.regi_pg_login_link::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  bottom: -2px;\n  width: 0%;\n  height: 1.5px;\n  background: #d8792e;\n  transition: width 0.25s ease;\n}\n\n.regi_pg_login_link:hover {\n  color: #b56010;\n}\n\n.regi_pg_login_link:hover::after {\n  width: 100%;\n}\n\n/* ============================================================\n   RESPONSIVE — tablet\n   ============================================================ */\n\n@media (max-width: 1024px) {\n  .regi_pg_left {\n    flex: 0 0 40%;\n    padding: 40px 40px;\n  }\n\n \n\n  .regi_pg_right {\n    padding: 40px 28px;\n  }\n}\n\n@media (max-width: 860px) {\n  .regi_pg_container {\n    flex-direction: column;\n  }\n\n  .regi_pg_left {\n    flex: none;\n    min-height: auto;\n    padding: 36px 32px 44px;\n  }\n\n  .regi_pg_left::before {\n    animation-duration: 40s;\n  }\n\n \n  .regi_pg_right {\n    min-height: auto;\n    padding: 40px 24px 56px;\n  }\n}\n\n/* ============================================================\n   RESPONSIVE — mobile\n   ============================================================ */\n\n@media (max-width: 560px) {\n  .regi_pg_left {\n    padding: 28px 22px 36px;\n  }\n\n  .regi_pg_logo_side_img,\n  .regi_pg_logo_img {\n  /* border-radius: 50%; */\n  object-fit: contain;\n  background: rgb(255, 255, 255);\n  padding: 20px;\n  height: 108px;\n  width: 108px;\n  margin-top: -15rem;\n  }\n\n  .regi_pg_right {\n    padding: 32px 18px 48px;\n  }\n\n  .regi_pg_title {\n    font-size: 23px;\n  }\n\n  .regi_pg_form {\n    gap: 15px;\n  }\n\n  .regi_pg_input {\n    padding: 12px 13px;\n    font-size: 14px;\n  }\n\n  .regi_pg_submit_btn {\n    padding: 13px 18px;\n    font-size: 14.5px;\n  }\n}\n\n\n/* ============================================================\n   Respect reduced motion\n   ============================================================ */\n\n@media (prefers-reduced-motion: reduce) {\n  .regi_pg_left::before,\n  .regi_pg_left::after,\n  .regi_pg_logo_row,\n \n\n  .regi_pg_stats,\n  .regi_pg_form_wrap,\n  .regi_pg_field,\n  .regi_pg_checkbox_row,\n  .regi_pg_submit_btn,\n  .regi_pg_login_text {\n    animation: none !important;\n    opacity: 1 !important;\n    transform: none !important;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
